import PublicService from '@/service/public'
import { handleImgSize } from '@/common/utils/map_view_data'
export default {
    data () {
        return {
            top_banner_recommendation_loading: true,
            top_banner_recommendation: []
        }
    },
    onLoad () {
        this.getTopBanner()
    },
    onPullDownRefresh () {
        if (!this.top_banner_recommendation_loading) {
            this.getTopBanner()
        }
    },
    methods: {
        async getTopBanner () {
            const { building_id } = this.$route.query
            const data = await PublicService.getBanner('building_detail_top_banner', 10, { building_id })
            data.forEach((item) => {
                item.photo_url = handleImgSize(item.photo_url, 750, 500)
            })
            this.top_banner_recommendation_loading = false
            this.top_banner_recommendation = data
        }
    }
}